export var ArticleCounterType;
(function (ArticleCounterType) {
    ArticleCounterType[ArticleCounterType["FOLLOWER"] = 10] = "FOLLOWER";
    ArticleCounterType[ArticleCounterType["VIEW"] = 20] = "VIEW";
    ArticleCounterType[ArticleCounterType["VOTE"] = 30] = "VOTE";
    ArticleCounterType[ArticleCounterType["UNHELPFUL"] = 300] = "UNHELPFUL";
    ArticleCounterType[ArticleCounterType["HELPFUL"] = 304] = "HELPFUL";
})(ArticleCounterType || (ArticleCounterType = {}));
//# sourceMappingURL=article-counter.js.map